<script setup>
import { MessageCircle, PhoneCall } from 'lucide-vue-next'

const isFlipped = ref(false)
let flipInterval = null

function openChat() {
  window.jivo_api?.open()
}

onMounted(() => {
  flipInterval = setInterval(() => {
    isFlipped.value = !isFlipped.value
  }, 5000)
})

onUnmounted(() => {
  clearInterval(flipInterval)
})
</script>

<template>
  <div class="flip-card relative w-80 h-12 group">
    <div
      class="flip-card-inner w-full h-full transition-transform duration-500 transform preserve-3d"
      :class="{ 'rotate-x-180': isFlipped }"
    >
      <!-- Front side - Phone -->
      <div class="flip-card-front absolute w-full h-full backface-hidden rounded-xl flex items-center gap-4 p-2 md:p-4">
        <div class="bg-gradient-to-br from-green-500 to-green-400 rounded-full p-3 shadow-md">
          <PhoneCall class="w-6 h-6  text-white" />
        </div>
        <div class="flex flex-col items-start">
          <a class="w-full text-center text-base font-bold text-gray-800 hover:text-green-500 transition-colors" href="tel:88007707345">
            8 (800) 770-73-45
          </a>
          <p class="text-sm text-[#849AAE]">
            09:00 - 16:00 мск, рабочие дни
          </p>
        </div>
      </div>

      <!-- Back side - Chat -->
      <div class="flip-card-back absolute w-full h-full backface-hidden rounded-xl rotate-x-180 flex items-center gap-4 p-2 md:p-4 cursor-pointer" @click="openChat">
        <div class="bg-gradient-to-br from-primary to-blue-400 rounded-full p-3 shadow-md">
          <NuxtImg
            src="data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2225%22%20viewBox%3D%220%200%2030%2031%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M2.967%2022.226l-.025.008s7.698%2013.9%2026.975%205.546c0%200-1.495-1.752-4.384-3.52a14.067%2014.067%200%200%200%202.588-14.047c-2.655-7.297-10.7-11.07-17.964-8.425C2.89%204.433-.847%2012.492%201.81%2019.79c.313.863.703%201.677%201.157%202.436z%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E%0A"
            alt="chat"
            class="w-6 h-6"
          />
        </div>
        <div class="flex flex-col items-start">
          <span class="text-base font-bold text-gray-800 group-hover:text-primary transition-colors">
            В чате все решаем быстрее
          </span>
          <p class="text-sm text-[#849AAE]">
            09:00 - 21:00 мск, без выходных
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.rotate-x-180 {
  transform: rotateX(180deg);
}

.preserve-3d {
  transform-style: preserve-3d;
}

.backface-hidden {
  backface-visibility: hidden;
}

.flip-card {
  perspective: 1200px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  -moz-backface-visibility: hidden;
}

/* Анимация плавающего эффекта */
.flip-card:hover .flip-card-inner {
  transform: translateY(-2px);
}

/* Анимация автопереворота */
@keyframes flipPause {
  0%, 40% { transform: rotateX(0deg) translateY(0); }
  45% { transform: rotateX(15deg) translateY(-3px); }
  50%, 90% { transform: rotateX(180deg) translateY(0); }
  95% { transform: rotateX(165deg) translateY(-3px); }
  100% { transform: rotateX(0deg) translateY(0); }
}

.flip-card-inner {
  animation: flipPause 10s infinite ease-in-out;
}
</style>
